import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/shipAccount/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/shipAccount',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/shipAccount',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/shipAccount/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/shipAccount',
    method: 'get',
    params: {
      id
    }
  })
}
export function listOption(params) {
  return request({
    url: '/api/business/shipAccount/listOption',
    method: 'get',
    params
  })
}
